import { mockFormOverrideAddressFieldset } from '@domgen/dgx-fe-forms/address';
import { mockFormField, mockFormFieldset } from '@domgen/dgx-fe-forms/layout';
import { CmsApplianceDetailsSteppedForm } from '../../models/appliance-details-stepped/cms-appliance-details-stepped-form.interface';
export const mockCmsApplianceDetailsSteppedForm: CmsApplianceDetailsSteppedForm =
  {
    brandCodeField: {
      fieldLabel: 'What brand is your appliance?',
      fieldRequired: true,
    },
    applianceCategoryCodeField: {
      fieldLabel: 'What appliance are you registering?',
      fieldRequired: true,
    },
    applianceCodeField: {
      fieldLabel: 'Can you tell us what type of appliance it is?',
      fieldRequired: true,
    },
    applianceBuiltInCodeField: {
      fieldLabel: 'Is your appliance built in?',
      fieldRequired: true,
    },
    purchasePriceField: {
      fieldLabel: 'How much did the appliance cost?',
      fieldHint: 'Approximately, how much did it cost?',
      fieldRequired: true,
    },
    purchaseDateField: {
      fieldLabel: 'When did you purchase it?',
      fieldHint: 'Select an approximate purchase date',
      fieldRequired: true,
    },
    retailerField: {
      fieldLabel: 'Which retailer did you purchase from?',
      fieldHint: 'Select a retailer',
      fieldRequired: false,
    },
    modelAndSerialNumberFieldset: {
      ...mockFormFieldset,
      modelNumberField: {
        fieldLabel: 'Model number',
        fieldRequired: false,
      },
      serialNumberField: {
        fieldLabel: 'Serial number',
        fieldRequired: false,
      },
    },
    personFieldset: {
      ...mockFormFieldset,
      addressFieldset: mockFormOverrideAddressFieldset,
      firstNameField: mockFormField,
      lastNameField: mockFormField,
      titleIdField: mockFormField,
    },
    warrantyField: {
      fieldLabel: 'Warranty',
      fieldHint: 'Select an approximate purchase date',
      fieldRequired: true,
    },
  };
